// API utility functions for handling base URL
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const getApiUrl = (endpoint) => {
  // Use relative API routes for Vercel serverless functions
  const cleanEndpoint = endpoint && typeof endpoint === 'string' && endpoint.startsWith('/') ? endpoint.slice(1) : endpoint || '';
  return `/api/${cleanEndpoint}`;
};

export const getUploadUrl = (endpoint) => {
  // Handle undefined/null endpoint
  if (!endpoint || typeof endpoint !== 'string') {
    return '/images/placeholder.png';
  }

  // If it's already a full URL (starts with http), return as-is
  if (endpoint.startsWith('http://') || endpoint.startsWith('https://')) {
    return endpoint;
  }

  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // For local images in public folder, use relative path
  if (cleanEndpoint.startsWith('images/') || !cleanEndpoint.includes('/')) {
    return `/${cleanEndpoint}`;
  }

  // For API upload paths, use relative URLs for Vercel
  if (cleanEndpoint.startsWith('products/')) {
    return `/uploads/${cleanEndpoint}`;
  }

  // For API paths like /api/uploads/products/, use relative URLs
  if (cleanEndpoint.startsWith('api/uploads/products/')) {
    const pathWithoutApi = cleanEndpoint.replace('api/', '');
    return `/${pathWithoutApi}`;
  }

  // For Cloudinary URLs, ensure proper format
  return `https://res.cloudinary.com/ddbc2v8xn/image/upload/${cleanEndpoint}`;
};

export const getVideoUrl = (endpoint) => {
  // Handle undefined/null endpoint
  if (!endpoint || typeof endpoint !== 'string') {
    return 'https://res.cloudinary.com/ddbc2v8xn/video/upload/placeholder.mp4';
  }
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `https://res.cloudinary.com/ddbc2v8xn/video/upload/${cleanEndpoint}`;
};